import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffShopServiceTokensNew from '../shops/TaroffShopServiceTokensNew';
import TaroffShopServiceTokensDelete from '../shops/TaroffShopServiceTokensDelete';
import { postData } from '../../Api';

export default function TaroffServiceTokens(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        setModal(
            Modal({
                children: <TaroffShopServiceTokensNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp2 = () => {
        setModal(
            Modal({
                children: <TaroffShopServiceTokensNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const [filterQKey, setFilterQKey] = useState(allProps['q-key'] || '');
    const [filterQShop, setFilterQShop] = useState(allProps['q-shop'] || '');
    const [filterQIp, setFilterQIp] = useState(allProps['q-ip'] || '');
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQKey('');
        setFilterQShop('');
        setFilterQIp('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQKey && (newSearchParams['q-key'] = filterQKey);
        filterQShop && (newSearchParams['q-shop'] = filterQShop);
        filterQIp && (newSearchParams['q-ip'] = filterQIp);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-service-tokens/table-data', {
            size: tableSize,
            page: tablePage,
            q_key: filterQKey,
            q_shop_title: filterQShop,
            q_ip_address: filterQIp,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp3 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffShopServiceTokensDelete
                        taroff-shop-service-tokens-id={row.param_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>توکن های دسترسی به سرویس</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        ایجاد توکن
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <SearchBox
                    onEnter={applyFilters}
                    label={'توکن'}
                    value={filterQKey}
                    onChange={setFilterQKey}
                    width={'180px'}
                />
                <SearchBox
                    onEnter={applyFilters}
                    label={'فروشگاه'}
                    value={filterQShop}
                    onChange={setFilterQShop}
                    width={'200px'}
                />
                <SearchBox
                    onEnter={applyFilters}
                    label={'آی پی'}
                    value={filterQIp}
                    onChange={setFilterQIp}
                    width={'160px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>ردیف</TableColumn>
                        <TableColumn mobile={false}>توکن</TableColumn>
                        <TableColumn mobile={false}>فروشگاه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>آی پی</TableColumn>
                        <TableColumn mobile={false}></TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}></TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_key}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_shop_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}></TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_ip_address}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <Button
                                    onClick={() => handlecomp3(row)}
                                    color={'warn'}
                                    rightIcon={'far fa-trash'}
                                    tooltip={'حذف'}
                                ></Button>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
